import React from 'react';
import Arrow from '../../../assets/arrow.svg';
import './index.scss';

const CarouselButton = (props) => {
    const {
        direction,
        onSlide,
    } = props;

    return (
        <button
            onClick={onSlide}
            className={`slideshow_button ${direction}`}
        >
            <img
                src={Arrow}
                className={`arrow_${direction}`}
                alt='arrow' />
        </button>
    )
}

export default CarouselButton;